import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "flowbite-react";
import axios from "axios";
const SyncPDVdbModal = ({openModal,setOpenModal}) => {

    const handleSync = async () => {
        try {
            const response = await axios.post( `${process.env.REACT_APP_BACKEND_URL}sync-pdvs`,
                {},
                {
                  withCredentials: true,
                });
            
        } catch (error) {
            console.error(error); // Handle error response
        } finally {
            setOpenModal(false); // Close the modal after sync
        }
    }

  return (
    <Modal show={openModal} onClose={() => setOpenModal(false)}>
    <ModalHeader>Sync PDV Database</ModalHeader>
    <ModalBody>
      <div className="space-y-6">
        <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
          You are about to sync the agents and users collections from pos DB to Pdvs and users collections from stock management.
        </p>
        <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
          Are you sure you want to proceed? This action cannot be undone.
        </p>
      </div>
    </ModalBody>
    <ModalFooter>
      <Button onClick={handleSync} color={"dark"}>I accept</Button>
      <Button color="gray" onClick={() => setOpenModal(false)}>
        Decline
      </Button>
    </ModalFooter>
  </Modal>
  )
}

export default SyncPDVdbModal



